
import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { callApiAction } from "../../store/actions/commonAction";
import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { callSnackBar } from "../../store/actions/snackbarAction";
import {  SNACK_BAR_VARIETNS } from "../../utils/constants";
import { deleteVersion, fetchVersions } from "../../apis/version.api";
// import { findObjectKeyByValue, unEscapeStr } from "../../utils/helper";
import VersionListUi from "./VersionListUi";
import MessageDilog from "../../components/MessageDilog";
import moment from "moment";
import VersionCreateController from "./VersionCreateController";
import { unEscapeStr } from "../../utils/main";

const ActionComponent = memo(({ params, setParams, deleteApi }) => {
    const dispatch = useDispatch();
    const modalkey = "edit";
    
    const [loading, setLoading] = useState(false);

 

    const deleteFun = async (e) => {
        e.preventDefault()
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await deleteVersion({ id: params._id }),
                (response) => {
                    setParams({});
                    setLoading(false);
                    dispatch(closeModal("messagedialogdelete"));
                    dispatch(callSnackBar(params.name + " Deleted Successfully", SNACK_BAR_VARIETNS.suceess))

                },
                (err) => {
                    setLoading(false);
                }
            )

        );


    };

    const onDelete = () => {
        dispatch(
            openModal(
                <MessageDilog
                    onSubmit={(e) => deleteFun(e)}
                    title="Alert!"
                    modalId="messagedialogdelete"
                    message={`Are you sure to delete "${params.name || params.title}" ?`}
                />,
                "sm",
                false,
                "messagedialogdelete"
            )
        );
    };

    return (
        <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
            
            <IconButton disabled={loading} size="inherit" onClick={onDelete}>
                <Delete color="error" fontSize="inherit" />
            </IconButton>
        </Box>
    );
});


const VersionListController = () => {
    const dispatch = useDispatch();
    const title = "version";
    const [loading, setLoading] = useState(false);
      const id = 'version';

    const columns = useMemo(
        () => [
            { id: 0, fieldName: 'launch_date', label: 'Launch Date', align: "left", sort: true, minWidth: '150px', renderValue: (params) => moment(params.launch_date).format("DD/MM/YYYY") },
        
            { id: 1, fieldName: 'name', label: 'Name', align: "left", sort: true, minWidth: '150px' },
        
        { id: 4, fieldName: 'main_version', label: 'Main Version', align: "left", sort: true, minWidth: '150px', renderValue: (params) => params.main_version + "." + params.sub_version },
        { id: 2, fieldName: 'description', label: 'description', align: "left", renderValue: (params) => <Box
         dangerouslySetInnerHTML={{ __html: unEscapeStr(params.description) }} 
         
         
         /> },
        {
            id: 3, fieldName: 'action', label: 'Action', align: "left", renderValue: (params, setParams) => <Box sx={{ display: "flex" }}>

                <ActionComponent params={params} setParams={setParams} />

            </Box>
        },
        ],
        [dispatch]
    );
    const [list, setList] = useState();
    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: "",
        searchable: ["name"],
        sort: "launch_date",
        sortDirection: -1,
    });


    const fetchList = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await fetchVersions({ ...filters }),
                (response) => {
                    setList(response)
                    setLoading(false);
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    };
  const onCreateBtnClick = () => {
  dispatch(openModal(
    <VersionCreateController callBack={fetchList} />, "sm", false, id))
}
    useEffect(() => {
        fetchList();
    }, [filters]);


    return (
        <VersionListUi
            title={title}
            filters={filters}
            setFilters={setFilters}
            loading={loading}
            list={list}
            onCreateBtnClick={onCreateBtnClick}
            columns={columns}
        />
    )
}

export default VersionListController